<script>
  import { onMount } from "svelte";
  import Header from "../../views/Header.svelte";

  let visible = false;

  onMount(() => {
    setTimeout(() => {
      visible = true;
    }, 50);
  });
</script>

<style lang="scss">
  .headline {
    display: flex;
    flex-direction: column;
    padding: 0 15em;
    opacity: 1;
    background: transparent url('../assets/installation-headline-bg-2.png') 0% 0% no-repeat padding-box;
    background-size: contain;
    height: 50em;

    visibility: hidden;
    opacity: 0;

    &.visible {
      transition: opacity 0.1s;
      visibility: visible;
      opacity: 1;
    }
    .headline__article {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin: auto;
      margin-top: 10em;

      .headline__text {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;

        h3 {
          width: 12em;
          text-align: center;
        }

        p {
          color: var(--font-color-alternative);
          font-weight: bold;
          font-size: 22px;
          letter-spacing: 0;
          line-height: 30px;
          width: 42em;
          text-align: center;
          margin-top: 10.5em;
        }
      }
    }
  }
</style>

<section class="headline" class:visible={visible}>
  <Header />
  <article class="headline__article">
    <section class="headline__text">
      <h3 class="header-title wc">Installation guide</h3>
    </section>
  </article>
</section>
